import {
  Component,
  Directive, ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, Subscription } from 'rxjs';


@Component({
    selector: 'app-loading-component',
    template: `
    <div class="loader-overlay">
      <div class="loader align-self-center"></div>
    </div>
  `,
    standalone: false
})
export class LoadingComponent {

}


@Directive({
    selector: '[appLoadingOverlay]',
    standalone: false
})
export class LoadingDirective implements OnDestroy {
  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loaderElement: HTMLElement;
  loadingChange: Subscription;

  @Input('appLoadingOverlay')
  set loading(loading: boolean) {
    this.isLoading.next(loading);
  }

  constructor(
    viewContainerRef: ViewContainerRef,
    private readonly renderer: Renderer2,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {
    const loaderElement = viewContainerRef.createComponent<LoadingComponent>(LoadingComponent);

    this.elementRef.nativeElement.classList.add('position-relative');
    this.loaderElement = loaderElement.location.nativeElement;
    this.renderer.appendChild(this.elementRef.nativeElement, this.loaderElement);

    this.loadingChange = this.isLoading
      .pipe(distinctUntilChanged())
      .subscribe(loading => {
        if (loading) {
          this.showLoadingIndicator();
        } else {
          this.hideLoadingIndicator();
        }
      });
  }

  ngOnDestroy(): void {
    this.loadingChange.unsubscribe();
  }

  private hideLoadingIndicator(): void {
    this.loaderElement.style.display = 'none';
    this.elementRef.nativeElement.style.pointerEvents = 'auto';
  }

  private showLoadingIndicator(): void {
    this.loaderElement.style.display = 'block';
    this.elementRef.nativeElement.style.pointerEvents = 'none';
  }
}
